import styled from 'styled-components';
import {
  NavLink,
} from 'react-router-dom';

import {
  Flex,
  icons,
} from 'web-styled';

export const Sidebar = styled(Flex).attrs({
  flex: '0 0 230px',
  width: '230px',
  column: true,
})`
  height: 100%;
  transition: flex .5s ease;
  box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.04);
  background: ${props => props.theme.colors.bgBlack};

  @media print {
    display: none;
  }
`;

type LogoProps = {
  logo: string | null;
};

export const Logo = styled(NavLink)<LogoProps>`
  flex: 0 0 64px;
  width: 230px;
  background-size: 170px;
  background-color: #23292b;
  background-image: url(${props => props.logo || icons.gymcloudLogo});
  background-repeat: no-repeat;
  background-position: center center;
`;

type LinkProps = {
  isopen: boolean;
  isDraggable: boolean;
};
export const StyledLink = styled(NavLink)<LinkProps>`
  display: flex;
  width: 100%;
  flex: 0 0 46px;
  box-sizing: border-box;
  margin: 0;
  font-size: 15px;
  font-weight: 300;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.65);
  border-left: 2px solid transparent;
  padding: 14px 7px 14px 14px;
  background-color: ${props => (props.isopen ? '#3c4248' : 'transparent')};
  position: relative;

  & > .fa,
  & > .far,
  & > .fas {
    position: relative;
    top: 3px;
    left: 1px;
    margin-right: 9px;
  }

  &:hover {
    color: #fff;
    & > span {
      opacity: 1;
      background-position: left top;
    }
  }

  &.selected {
    color: ${props => props.theme.colors.sidebarLink};
    border-left-color: ${props => props.theme.colors.sidebarLink};

    &:hover {
      color: ${props => props.theme.colors.sidebarLink};
    }

    & > span {
      opacity: 1;
      background-position: right top;
    }
  }

  ${props => props.isDraggable && `
    cursor: move;
  `}
`;

export const SVGIcon = styled.span`
  position: relative;
  left: -3px;
  top: 0px;
  opacity: 0.65;

  svg {
    height: 18px !important;
    width: 16px !important;
  }
`;

export const Name = styled.span`
  padding: 0 0 0 5px;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
  overflow-y: hidden;
  max-width: 150px;
`;

export const Arrow = styled.div<{isOpen: boolean}>`
  width: 20px;
  height: 20px;
  position: relative;
  top: 0px;
  right: -10px;
  transform: rotate(${props => (props.isOpen ? '-90deg' : '90deg')});
  background: url(${icons.sidebarArrow}) center center no-repeat;
  margin-left: auto;
  margin-right: 15px;
`;

type SupProps = {
  isOpen: boolean;
  showLine: boolean;
  leftLine: string;
};
export const Sub = styled(Flex).attrs({
  width: '100%',
  column: true,
})<SupProps>`
  overflow: hidden;
  background: #2f3539;
  position: relative;
  transition: max-height 0s ease-out;
  max-height: ${props => (props.isOpen ? 'inherit' : 0)};
  position: relative;
  ${props => props.showLine && `
    &:before {
      display: block;
      content: "";
      position: absolute;
      bottom: 5px;
      top: 5px;
      left: ${props.leftLine};
      width: 0;
      border-left: 1px solid #fff;
      z-index: 1;
    }
  `}
`;

export const Badge = styled.span`
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 50%;
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: ${props => props.theme.colors.sidebarLink};
`;
